import { defaultTheme } from 'gd-design-library';

export const inlineNotification = {
  ...defaultTheme.inlineNotification,
  default: {
    ...defaultTheme.inlineNotification.default,
    wrapper: {
      ...defaultTheme.inlineNotification.default.wrapper,
      alignItems: 'flex-start',
      gap: '10px',
      padding: '8px 16px 8px 12px',
      borderRadius: '1.5rem'
    },
    content: {
      ...defaultTheme.inlineNotification.default.content,
      fontWeight: '400'
    }
  },
  error: {
    ...defaultTheme.inlineNotification.error,
    wrapper: {
      ...defaultTheme.inlineNotification.error.wrapper,
      backgroundColor: defaultTheme.colors.red[10],
      color: defaultTheme.colors.red[60]
    },
    icon: {
      ...defaultTheme.inlineNotification.error.icon,
      width: '20px',
      height: '20px'
    }
  }
};
